import { NocoHttpClient } from '@noco/http-client';
import { createConfigurationWithToken } from '../utils';
var Configuration = NocoHttpClient.Configuration;
var ContactListApi = /** @class */ (function () {
    function ContactListApi(basePath, fetchApi) {
        this.basePath = basePath;
        this.fetchApi = fetchApi;
    }
    ContactListApi.initialize = function (basePath, fetchApi) {
        if (!ContactListApi.instance) {
            ContactListApi.instance = new ContactListApi(basePath, fetchApi);
        }
        return ContactListApi.instance;
    };
    ContactListApi.prototype.ApiFactory = function (idToken) {
        var config = createConfigurationWithToken({
            basePath: this.basePath,
            fetchApi: this.fetchApi,
            idToken: idToken,
            type: 'user'
        });
        return new NocoHttpClient.ApiUserV1ContactListApi(new Configuration(config));
    };
    return ContactListApi;
}());
export { ContactListApi };
